'use client';

import dynamic from 'next/dynamic';

export const WhatIsMyIpHeroStrapi = dynamic(() =>
  import('./WhatIsMyIpHeroStrapi').then((m) => m.WhatIsMyIpHeroStrapi)
);
